var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"g-layout-user-menu"},[_c('li',{on:{"click":function($event){return _vm.changeLanguage('zh-CN')}}},[_vm._v(" 简体中文 ")]),_c('li',{on:{"click":function($event){return _vm.changeLanguage('en-US')}}},[_vm._v(" English ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }